import "./vision.css";
import Card from "./Card/card"

let Vision = () => {
  return (
   <div className="vision">
            <div className="header">
              <div className="heading">OUR VISION</div>
            </div>
         <h3 className="vision-tagline">Technology is best when it brings people together!!!</h3>
         <br />
         <h3 className="la">-Matt Mullenweg</h3>

    <div className="cards">

    <Card 
      img="https://us.123rf.com/450wm/batsheba/batsheba2001/batsheba200100001/139407875-school-children-learning-coding-in-science-classroom-vector-illustration.jpg?ver=6"
      title="OPPORTUNITIES"
      description="Several Coding Contests, hackathons are timely organised for the tech enthusiasts and many other opportunities are provided.
      Not only professional but for personal development and for enhacing public speaking skills, mentor sessions are conducted and programs like Uplift GDSC are organised. GDSC GTBIT is a community where everyone is treated equal and given a fair chance to showcase their talent."/>


      <Card 
      img="https://miro.medium.com/max/1200/1*d-z4KqFcIUey4l6dqcXCaQ.jpeg"
      title="LEARNING"
      description="Webinars by specially trained mentors on various technologies like IOT, AI etc are conducted. 
      Valuable Resources for deep understanding are provided by the team leaders and mentors.
      Seasonal programmes like 30 days of Google Cloud Programming, Hacktober GTBIT, and more are organised to make learning fun and interactive. The aim is to utilise quality resources available and upskill." 
      />
      
      <Card 
      img="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS11xwobn-3a-wS270v02TnRsXbqeJg1KDptQ&usqp=CAU"
      title="EXPERIENCES"
      description="The GDSC community at GTBIT has successful alumni that are always ready to guide and support the young and new members of the community. Regulars sessions and mentorship seminars are organised for the alumni to share their wonderful experiences and motivate others.
      Leadership Qualities and team work are highly promoted and the overall experience is ensured to be great and worth remembering!"/>
    </div>
    </div>
  );
}

export default Vision;